import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d96c9726&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d96c9726&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96c9726",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d96c9726')) {
      api.createRecord('d96c9726', component.options)
    } else {
      api.reload('d96c9726', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d96c9726&scoped=true", function () {
      api.rerender('d96c9726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/giftTag/index.vue"
export default component.exports